import * as angular from 'angular';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import ResetByQuestionName, {openResetByQuestion} from "./resetByQuestion";
import SelectResetOptionName, {openSelectResetOption} from "./selectResetOption";
import {States} from "../../shared/config/constant.module";
import template from './signIn.tpl.html';
import AuthServiceName, {AuthService} from "../../services/auth/auth.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ResetPasswordServiceName, {ResetPasswordService} from "../../services/resetPassword/resetPassword.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import UserProfileName, {UserProfile} from "../../models/userProfile";

let requires = [ResetByQuestionName, SelectResetOptionName, AuthServiceName, AuthDataServiceName, NotifyServiceName,
  LoaderServiceName, ResetPasswordServiceName, NavigationServiceName, UserProfileName];

interface SignInForm extends angular.IFormController {
  username: angular.IFormController;
}

interface SignInController {
  form: SignInForm;
  username: string;
  password: string;
  code: string;
  tokenMode: boolean;
  message: string;
  signIn(): void;
  forgotPassword(): void;
}

export default angular.module('aps.controller.signIn', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.SIGN_IN,
      url: '/signIn',
      controller: 'SignIn as signIn',
      template: template,
      data: {pageTitle: 'Login'}
    });
  })
  .controller('SignIn', signInCtrl)
  .name;

function signInCtrl(
  $state: angular.ui.IStateService,
  authService: AuthService,
  authDataService: AuthDataService,
  notifyService: NotifyService,
  loaderService: LoaderService,
  resetPasswordService: ResetPasswordService,
  navigationService: NavigationService,
  userProfile: UserProfile,
  $modal: mm.foundation.modal
) {

  var vm = this as SignInController;
   
  authService.logoff(null);
  userProfile.update(null);

  function signIn(): void {
    if (vm.form.$invalid) {
      return;
    }

    var promise = authService.login(vm.username, vm.password, vm.code)
      .then(() => {
        userProfile.read();

        var userId = authDataService.getUserId();
        var selectedRole = authDataService.getSelectedRoleLocation();
        if (selectedRole) {

          var plantId = selectedRole.plant ? selectedRole.plant.id : undefined;
          var shopId = selectedRole.shop ? selectedRole.shop.id : undefined;

          var goToDashboard = () => {
            authService.getUserData().then(() => {
              $state.go(States.ADMIN_DASHBOARD, {
                plantId: plantId,
                shopId: shopId,
                userId: userId
              });
            });
          };

          if (plantId && shopId) {
            goToDashboard();
          } else {
            return navigationService.getNavigation().then((navigation) => {
              plantId = navigation.selectedPlant.id;
              shopId = navigation.selectedShop.id;
              authDataService.setSelectedRoleLocation(selectedRole.role,
                navigation.selectedPlant, navigation.selectedShop);
              goToDashboard();
            });
          }
        } else {
          $state.go(States.SELECT_ROLE, {userId: userId});
        }
      }, (resp) => {
        if(resp.data != null && resp.data.error != null && resp.data.error == "MFA")
        {
            vm.form.tokenMode = true;
            vm.form.message = resp.data.error_description;
        }
        else{
          notifyService.error('Username or password is incorrect');
        }
      });

    loaderService.loadingPromise(promise);
  }

  function forgotPassword(): void {
    if (vm.form.username.$invalid) {
      notifyService.error('Please enter your username to reset your password.');
      return;
    }

    resetPasswordService.getResetOptions(vm.username)
      .then(optionsSuccess, notifyService.handleApiErrors);

    function resetByEmail(): void {
      var submitForgot = resetPasswordService
        .sendResetPasswordEmail(vm.username)
        .then(() => {
          notifyService.success('Your password has been reset. Please check your email.');
        }, notifyService.handleApiErrors);
      loaderService.loadingPromise(submitForgot);
    }

    function resetByQuestion(options: apsViewModels.PasswordResetOptions): void {
      openResetByQuestion(vm.username, options, $modal);
    }

    function openSelectOptions(options: apsViewModels.PasswordResetOptions): void {
      let result = openSelectResetOption($modal);

      result.then((selected: any) => {
        if (!selected) {
          return;
        }

        if (selected.question) {
          resetByQuestion(options);
          return;
        }

        if (selected.email) {
          resetByEmail();
        }
      });
    }

    function optionsSuccess(options: apsViewModels.PasswordResetOptions): void {
      if (options.canResetWithEmail && options.canResetWithQuestion) {
        openSelectOptions(options);
        return;
      }

      if (options.canResetWithEmail) {
        resetByEmail();
        return;
      }

      if (options.canResetWithQuestion) {
        resetByQuestion(options);
        return;
      }

      notifyService.error('Unable to reset your password. Please check your username or contact an administrator.');
    }
  }

  vm.signIn = signIn;
  vm.forgotPassword = forgotPassword;
}


// WEBPACK FOOTER //
// ./src/app/controllers/signIn/signIn.controller.ts